import { Paper, Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";
import { SectionProps } from "../sections/SectionProps";
import { LcmModel } from "../../domain/LcmModel";
import { MainDetails } from "../sections/MainDetails";
import { AoSection } from "../sections/AoSection";
import { TaggingSection } from "../sections/TaggingSection";

const useStyles = makeStyles(() => ({
  formHeading: {
    color: "#9f9f9f",
    fontSize: "1em",
    marginBottom: "30px",
    fontWeight: 600,
    position: "relative",
  },
  formSection: {
    padding: 30,
    boxShadow: "0 0 19px -2px hsla(0,0%,63.9%,.3)",
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    borderRadius: "3px",
  },
}));

export const ItemDetails: React.FC<{
  sectionProps: SectionProps<LcmModel>;
}> = ({ sectionProps }) => {
  const classes = useStyles();
  return (
    <>
      <div>
        <Typography variant="h6">Main Details</Typography>
        <Paper className={classes.formSection}>
          <MainDetails sectionProps={sectionProps} />
        </Paper>

        <Typography variant="h6">Awarding Organisation(s)</Typography>
        <Paper className={classes.formSection}>
          <AoSection sectionProps={sectionProps} />
        </Paper>

        <Typography variant="h6">[Tagging for search]</Typography>
        <Paper className={classes.formSection}>
          <TaggingSection sectionProps={sectionProps} />
        </Paper>
      </div>
    </>
  );
};
